<template>
    <app-modal name="invoice-review-modal"  :title="title" @before-open="beforeOpen" :is-submitting="isLoading"
        @before-close="beforeClose" width="30%" :submitOnEnter="false" @on-ok="onOk">
        <app-form ref="form" @on-submit="onSubmit" :schema="schema" :data="formModel" />
    </app-modal>
</template>

<script>
import AppModal from '@/components/app-modal/';
import AppForm from '@/components/app-form/';
import InvoiceProxy from '../../store/proxies/invoice-proxy';
// import { mapActions, mapState } from 'vuex';

export default {
    name: 'InvoiceReviewModal',
    components: {
        AppForm,
        AppModal,
    },
    data() {
        return {
            title: this.$t('invoice.paidDate'),
            invoicesId: [],
            isLoading: false,
            schema: [
                {
                    name: 'reason',
                    label: 'Lý do xem xét',
                    placeholder: `${this.$t('app.enter')} ${this.$t('invoice.paidDate')}`,
                    validation: 'required',
                    type: 'input',
                },
            ],
            formModel: {
                reason: ''
            }
        };
    },
    mounted() { },
    methods: {
        onSubmit(formModel) {
            return new InvoiceProxy().markInvoiceAsConsidered(
                this.invoicesId,
                formModel.reason
            )
        },
        onOk() {
            this.$refs.form.submit();
        },
        beforeClose() {
            this.formModel = {
                reason: null,
            };
        },
        beforeOpen(params) {
            this.invoicesId = params.model.invoicesId;
            // this.markedInvoices = params.markedInvoices;
            // this.formModel.email = this.companyMarked.latest_emails ? [{ text: this.companyMarked.latest_emails }] : [];
        },
    },
};
</script>
<style lang="scss">
.paid-modal-content {
    .paid-modal-information {
        padding: 16px;
        margin-bottom: 12px;
        border-radius: 12px;
        gap: 8px;
        display: flex;
        flex-direction: column;
        color: #003AAB;
        background: #CCE4F6;

        p {
            margin: 0;
        }

        //strong {
        //  font-weight: bold;
        //}
    }
}
</style>



// WEBPACK FOOTER //
// src/portal-components/invoice/invoice-review-modal.vue